import { TraceBoardColumn } from '../../../../common/trace-board/interfaces/TraceBoardColumn';
import { TraceBoardItem } from '../../../../common/trace-board/interfaces/TraceBoardItem';
import {
  useCreateProductDesignInput,
  useCreateProductDesignOutput,
  useCreateProductDesignSpec,
  useCreateProductUserNeed,
  useCreateProductValidation,
  useCreateProductVerification,
  useUpdateProductDesignInput,
  useUpdateProductDesignOutput,
  useUpdateProductDesignSpec,
  useUpdateProductUserNeed,
  useUpdateProductValidation,
  useUpdateProductVerification
} from '../../Product.hooks';

export default function useProductBoardUpdateEntities(productId: number) {
  const {
    createdProductUserNeed,
    createProductUserNeedError,
    createProductUserNeed
  } = useCreateProductUserNeed(productId);
  const {
    updatedProductUserNeed,
    updateProductUserNeed
  } = useUpdateProductUserNeed(productId);
  const {
    createdProductDesignInput,
    createProductDesignInputError,
    createProductDesignInput
  } = useCreateProductDesignInput(productId);
  const {
    updatedProductDesignInput,
    updateProductDesignInput
  } = useUpdateProductDesignInput(productId);
  const {
    createdProductDesignOutput,
    createProductDesignOutputError,
    createProductDesignOutput
  } = useCreateProductDesignOutput(productId);
  const {
    updatedProductDesignOutput,
    updateProductDesignOutput
  } = useUpdateProductDesignOutput(productId);
  const {
    createdProductVerification,
    createProductVerificationError,
    createProductVerification
  } = useCreateProductVerification(productId);
  const {
    updatedProductVerification,
    updateProductVerification
  } = useUpdateProductVerification(productId);
  const {
    createdProductValidation,
    createProductValidationError,
    createProductValidation
  } = useCreateProductValidation(productId);
  const {
    updatedProductValidation,
    updateProductValidation
  } = useUpdateProductValidation(productId);
  const {
    createdProductDesignSpec,
    createProductDesignSpecError,
    createProductDesignSpec
  } = useCreateProductDesignSpec(productId);
  const {
    updatedProductDesignSpec,
    updateProductDesignSpec
  } = useUpdateProductDesignSpec(productId);

  const handleAddItem = (
    newItem: Partial<TraceBoardItem>,
    sourceItem: TraceBoardItem | undefined,
    column: TraceBoardColumn,
    columnIndex: number
  ) => {
    const sourceItemIds = sourceItem ? [sourceItem.id] : [];
    switch (columnIndex) {
      case 0:
        createProductUserNeed({ title: newItem.description });
        break;
      case 1:
        createProductDesignInput({
          title: newItem.description,
          userNeedIds: sourceItemIds
        });
        break;
      case 2:
        createProductDesignOutput({
          title: newItem.description,
          designInputIds: sourceItemIds
        });
        break;
      case 3:
        createProductVerification({
          title: newItem.description,
          designOutputIds: sourceItemIds
        });
        break;
      case 4:
        createProductValidation({ title: newItem.description });
        break;
      case 5:
        createProductDesignSpec({ title: newItem.description });
        break;
    }
  };

  const handleUpdateItem = (
    item: Partial<TraceBoardItem>,
    column: TraceBoardColumn,
    columnIndex: number
  ) => {
    switch (columnIndex) {
      case 0:
        updateProductUserNeed({
          id: item.data.id,
          title: item.description
        });
        break;
      case 1:
        updateProductDesignInput({
          id: item.data.id,
          title: item.description
        });
        break;
      case 2:
        updateProductDesignOutput({
          id: item.data.id,
          title: item.description
        });
        break;
      case 3:
        updateProductVerification({
          id: item.data.id,
          title: item.description
        });
        break;
      case 4:
        updateProductValidation({
          id: item.data.id,
          title: item.description
        });
        break;
      case 5:
        updateProductDesignSpec({
          id: item.data.id,
          title: item.description
        });
        break;
    }
  };

  return {
    createdProductUserNeed,
    updatedProductUserNeed,
    createdProductDesignInput,
    updatedProductDesignInput,
    createdProductDesignOutput,
    updatedProductDesignOutput,
    createdProductVerification,
    updatedProductVerification,
    createdProductValidation,
    updatedProductValidation,
    createdProductDesignSpec,
    updatedProductDesignSpec,
    handleAddItem,
    handleUpdateItem
  };
}
